import { render, staticRenderFns } from "./FeatureCard.vue?vue&type=template&id=30811d1d&scoped=true&"
import script from "./FeatureCard.vue?vue&type=script&lang=js&"
export * from "./FeatureCard.vue?vue&type=script&lang=js&"
import style0 from "./FeatureCard.vue?vue&type=style&index=0&id=30811d1d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30811d1d",
  null
  
)

export default component.exports